import {
  fetchCreateOOBInvitationStarted,
  fetchCreateOOBInvitationSuccess,
  fetchCreateOOBInvitationError,
} from "./index";

// Creates a new out-of-band connection invitation
export const fetchCreateOOBInvitation = (presExId) => async (dispatch) => {
  // Request body
  const json = `{
      "attachments": [
          {
            "id": "${presExId}",
            "type": "present-proof"
          }
      ]
   }`;
  try {
    dispatch(fetchCreateOOBInvitationStarted());
    // POST request with set headers and body to create a new oob connection invitation
    const response = await fetch(
      `${process.env.REACT_APP_VERIFIER_URL}/out-of-band/create-invitation`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
          apiKey: `${process.env.REACT_APP_VERIFIER_API_KEY}`,
          Authorization: `Bearer ${process.env.REACT_APP_VERIFIER_TOKEN}`,
        },
        body: json,
      }
    );
    // Gets the response of the POST request
    const data = await response.json();
    if (!response.ok) {
      throw data.error;
    }
    return dispatch(fetchCreateOOBInvitationSuccess(data));
  } catch (error) {
    return dispatch(fetchCreateOOBInvitationError());
  }
};
